import Hero from "@/pages/home/components/Hero";
import Ticker from "@/components/feature/Ticker";
import HotRanking from "@/pages/home/components/HotRanking";
import CategoryExplorer from "@/pages/home/components/CategoryExplorer";
import LatestFeed from "@/pages/home/components/LatestFeed";
import DeepDive from "@/pages/home/components/DeepDive";
import Voices from "@/pages/home/components/Voices";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import useSeo from "@/hooks/useSeo";
import { siteInfo, faqs } from "@/mocks/site";

export default function Home() {
  useSeo({
    title: "18爆料网 - 明星塌房、艺人黑历史与娱乐圈内幕每日更新",
    description:
      "18爆料网聚合明星塌房现场、艺人黑历史与娱乐圈内幕，提供热榜、栏目分类与深度专题，多源比对梳理时间线，吃瓜不迷路，每天都有新瓜吃。",
    keywords: "18爆料网,明星塌房,艺人黑历史,娱乐圈内幕,明星黑料,娱乐热点",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        description: siteInfo.description,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: {
            "@type": "EntryPoint",
            urlTemplate: "https://18baoliao.com/topics?q={search_term_string}",
          },
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        email: siteInfo.email,
        description: siteInfo.description,
        foundingDate: siteInfo.founded,
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <Ticker />
      <HotRanking />
      <CategoryExplorer />
      <LatestFeed />
      <DeepDive />
      <Voices />
      <FaqSection />
      <SubscribeCta />
    </>
  );
}